import { render, staticRenderFns } from "./top-users-chart.vue?vue&type=template&id=5a9b0336&scoped=true"
import script from "./top-users-chart.vue?vue&type=script&lang=js"
export * from "./top-users-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b0336",
  null
  
)

export default component.exports